import { useState } from 'react';
import { usePartnerListQuery } from '@common/cache';
import { usePartnerTableStore } from '../Filters/filters.store';
import { useDrawerStore } from 'store/drawer.store.ts';

export const usePartner = () => {
  const { filters } = usePartnerTableStore();
  const [selectedPartnerId, setSelectedPartnerId] = useState<string>('');

  const setDrawerOpen = useDrawerStore(state => state.setDrawerOpen);
  const isDrawerOpen = useDrawerStore(state => state.isDrawerOpen);

  const {
    data = { count: 0, records: [] },
    isRefetching,
    isFetching,
  } = usePartnerListQuery(filters);

  const entries = data.records;

  const handleCloseDrawer = () => {
    setSelectedPartnerId('');
    setDrawerOpen(false);
  };

  const handleOpenPartnerDetails = (id: string) => {
    setSelectedPartnerId(id);
    setDrawerOpen(true);
  };

  return {
    entries,
    totalCount: data.count,
    isLoading: isRefetching || isFetching,
    selectedPartnerId,
    handleCloseDrawer,
    handleOpenPartnerDetails,
    isDrawerOpen,
  };
};
